import React, { Component } from 'react';
import PropTypes from 'prop-types';
import API_URL from '../../../../common/url';
import HeaderBar from '../../components/HeaderBar';
import TablePage from './TablePage';
import ChartsCollection from '../components/ChartsCollection';
import { genSubAuth } from '../../constants';

const countType = 0;
const Icons = [{ icon: '\ue659', order: 0 }, { icon: '\ue651', order: 1 }, { icon: '\ue656', order: 2 }];
function getCharts(type, angle) {
    const chartTitle = angle === '0' ? '合同约定请款金额合计' : '请款笔数';
    return (
        [{
            title: '超出milestone天数',
            chartTitle,
            type,
            key: 'overMilestoneDay',
            queryUrl: API_URL.requestDataAnalysis.queryOutCashReqNodeDaysCount,
            exportUrl: API_URL.requestDataAnalysis.exportOutCashReqNodeDaysCount,
        }, {
            title: '原因分类',
            chartTitle,
            type,
            key: 'reasonClassify',
            queryUrl: API_URL.requestDataAnalysis.queryRemark,
            exportUrl: API_URL.requestDataAnalysis.exportRemark,
        }, {
            title: '客户',
            chartTitle,
            type,
            key: 'client',
            queryUrl: API_URL.requestDataAnalysis.queryCustomer,
            exportUrl: API_URL.requestDataAnalysis.exportCustomer,
        }]
    );
}

class ArrivedMilestone extends Component {
    static contextTypes = {
        businessList: PropTypes.array,
        clientHeight: PropTypes.number,
        notice: PropTypes.object,
    }

    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            searchParams: {
                type: '0',
            },
        };
    }

    handleIconChange = (current) => {
        this.setState({ current });
    }

    handleChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    render() {
        const { businessList, clientHeight, notice } = this.context;
        const { auth } = this.props;
        const { current, searchParams } = this.state;
        const { type } = searchParams;

        return (
            <div className="pane-item">
                <HeaderBar
                    title="已到达milestone日期未开票的清单"
                    tip="已经到达“milestone到达日期”，但未开票的请款记录"
                    onChange={this.handleIconChange}
                    current={current}
                    icons={Icons}
                />
                {
                    current === 0 &&
                    <TablePage
                        notice={notice}
                        searchParams={searchParams}
                        businessList={businessList}
                        clientHeight={clientHeight}
                        onChange={this.handleChange}
                    />
                }
                {
                    current === 1 &&
                    genSubAuth(auth, 'histogram') &&
                    <ChartsCollection
                        countType={countType}
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                        onChange={this.handleChange}
                        charts={getCharts('histogram', type)}
                        auth={genSubAuth(auth, 'histogram')}
                    />
                }
                {
                    current === 2 &&
                    genSubAuth(auth, 'pie') &&
                    <ChartsCollection
                        countType={countType}
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                        onChange={this.handleChange}
                        charts={getCharts('pie', type)}
                        auth={genSubAuth(auth, 'pie')}
                    />
                }
            </div>
        );
    }
}

export default ArrivedMilestone;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/ArrivedMilestone/index.js